import { Input } from 'semantic-ui-react';
import classNames from 'classnames';
import './search-field.scss';

export default function SearchField({ onChange = () => {}, ...props }) {
  return (
    <div className="search-field-wrapper" role="search">
      <Input
        className={classNames('search-field', props.className)}
        icon="search"
        placeholder="Buscar..."
        {...props}
        onChange={(event, { value }) => onChange(value)}
      />
      <div
        role="img"
        aria-label="Clear search"
        className="search-field-wrapper__clear"
        onClick={(event) => onChange('')}
      >
        &times;
      </div>
    </div>
  );
}
